import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import * as Actions from 'actions';

import {
	OverlayTrigger,
	Popover
} from 'react-bootstrap';

class Feature extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			heading_open : false,
		}

		this.isOnlyChild = this.isOnlyChild.bind(this);
		this.isEnabled = this.isEnabled.bind(this);
		this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
		this.renderFeatureChildren = this.renderFeatureChildren.bind(this);
		this.handleClickFeature = this.handleClickFeature.bind(this);
	}

	isOnlyChild(feature) {
		// Checks for a feature in the featuresList that has the following qualities :
		//		-Same parent as the the 'feature' paramater
		//		-Isn't the same as the 'feature' parameter
		let current_features_owner;
		if(this.props.features.features_owner_type === 'User') {
			current_features_owner = this.props.users.tmp_user
		}
		else if(this.props.features.features_owner_type === 'Role') {
			current_features_owner = this.props.roleManagement.roles.find(r => r._id === this.props.roleManagement.selectedRole)
		}
		else if(this.props.current_entity) {
			current_features_owner = this.props.current_entity;
		}
		if(!current_features_owner)
			return false

   	let sibling = this.props.features.features_list.find(list_feature => {
  		return (list_feature.parent === feature.parent &&
  			(list_feature._id !== feature._id) &&
  			(current_features_owner.features.find(owner_feature => {
  				return owner_feature === list_feature._id
  			}) !== undefined))
  	})

  	if(sibling)
  		return false
  	else
  		return true
  }

	isEnabled(feature) {
		let tested_feature = (typeof feature === 'object' ? feature._id : feature)
		let current_features_owner;
		if(this.props.features.features_owner_type === 'Role') {
			current_features_owner = this.props.roleManagement.roles.find(r => r._id === this.props.roleManagement.selectedRole)
		}
		else if(this.props.features.features_owner_type === 'User') {
			current_features_owner = this.props.users.tmp_user;
		}
		else if(this.props.current_entity) {
			current_features_owner = this.props.current_entity;
		}

		if (current_features_owner &&
			current_features_owner.features) {
			var featureInRole = current_features_owner.features.find(f => {
				if(typeof f === 'string')
					return f === tested_feature
				else if (typeof f === 'object')	{
					return f._id === tested_feature
				}
				else
					console.log('error in isEnabled(feature)')
			});

			if (featureInRole) {
				return true;
			}
		}
		return false;
	}

	handleClickCheckbox(event) {
		let current_feature = this.props.feature_node.children.find(n => {
				return n.feature._id === event.target.id;
			}).feature

		let features_list = [];

		// ************* CASE : Checkbox is being checked ************* //
		if (event.target.checked) {

			// CASE : Checkbox being selected is the 'All' checkbox
			//	=> Check all unchecked boxes
			if(current_feature.name === 'All') {
				features_list.push(current_feature._id);

				this.props.feature_node.children.forEach(n => {
					if (!this.isEnabled(n.feature))
						features_list.push(n.feature._id)
				})
			}
			// Check for ancestors that need to be enabled
			let { path } = current_feature;
			let pathElements = path.split('/').filter(elem => (elem != ''));
			let paths = [];

			while(pathElements.length > 0) {
				paths.push(`/${pathElements.join('/')}/`);
				pathElements.pop();
			}

			let iterator = current_feature;
			paths.forEach(p => {
				iterator = this.props.features.features_list.find(f => f.path === p)

				if (iterator && !this.isEnabled(iterator))
					features_list.push(iterator._id);
			})
			if(this.props.features.features_owner_type === 'Role') {
				this.props.beginEnableFeatures(features_list)
			}
			else if(this.props.features.features_owner_type === 'User' ||
				this.props.features.features_owner_type === 'Plan' ||
				this.props.current_entity
			) {
				let event = {
					target : {value : 'on', name : 'features'},
					features : features_list
				}

				this.props.handleChange(event)
			}
		}

		// *************** CASE : Checkbox is being unchecked **************** //
		else {
			features_list.push(current_feature._id);

			// CASE : Checkbox being selected is the 'All' checkbox
			//	=> uncheck all checked boxes
			if(current_feature.name === 'All') {
				features_list.push(current_feature._id);

				this.props.feature_node.children.forEach(n => {
					if (this.isEnabled(n.feature))
						features_list.push(n.feature._id)
				})
			}

			// Check for ancestors that need to be disabled
			let iterator = current_feature;
			while(iterator) {
				if(iterator.parent && this.isOnlyChild(iterator)) {
					features_list.push(iterator.parent)
					iterator = this.props.features.features_list.find(f => f._id === iterator.parent)
				}
				else
					break
			}

			if(this.props.features.features_owner_type === 'Role') {
				this.props.beginDisableFeatures(features_list)
			}
			if(this.props.current_entity) {
				let event = {
					target : {value : 'on', name : 'features'},
					features : features_list
				}
				this.props.handleChange(event);
			}
			else {
				// Check if feature is enabled in role before disabling
				let users_role = this.props.users.tmp_user ? this.props.users.tmp_user.role_current : null
				if(users_role && users_role.features.find(role_feature => {
					return (
						(typeof role_feature === 'object') ?
						role_feature._id === current_feature._id :
						role_feature === current_feature._id
					)
				})) {
					this.props.notify(
						{ message : 'Can only disable features that are not enabled in the users role' }
					)
				}
				else {
					let event = {
						target : {value : 'off', name : 'features'},
						features : features_list
					}
					this.props.handleChange(event);
				}
			}
		}
	}

	renderFeatureChildren(current_feature_node, index, current_array) {
		// Check for grandchildren features
		if (current_feature_node.children.length != 0) {
			if(this.props.features.features_owner_type != '') {

				let N_Feature = connect(({features, roleManagement, users}) => ({features, roleManagement, users}), Actions)(Feature)
				return (
						<div key={current_feature_node.feature._id}>
							<N_Feature
								feature_node={current_feature_node}
								isNested={true}
								roleManagement={this.props.roleManagement}
								featuresHeadingOpenClassName={this.props.featuresHeadingOpenClassName}
								featuresHeadingClosedClassName={this.props.featuresHeadingClosedClassName}
								parentFeatureWrapperClassName={this.props.parentFeatureWrapperClassName}
								parentFeatureBodyClassName={this.props.parentFeatureBodyClassName}
								nestedFeatureWrapperClassName={this.props.nestedFeatureWrapperClassName}
								nestedFeatureBodyClassName={this.props.nestedFeatureBodyClassName}
								handleChange={this.props.handleChange}
								popoverPosition={this.props.popoverPosition}
								current_entity={this.props.current_entity}
							/>
						</div>
				)
			}
		}
		else {
			// Check if previous feature was nested, and if so, add a
			//	larger top margin
			var checkbox_classname;
			if (index != 0 && current_array[index-1].children.length != 0)
				checkbox_classname = 'checkbox-wrapper checkbox-below-nested checkbox-custom checkbox-default';
			else
				checkbox_classname = 'checkbox-wrapper checkbox-custom checkbox-default';
			// Move 'All' check box to the beginning of the children array
			return (
				<div key={current_feature_node.feature._id}>
					<div className={checkbox_classname}>
						<input
							type='checkbox'
							checked={this.isEnabled(current_feature_node.feature._id)}
							id={current_feature_node.feature._id}
							onChange={this.handleClickCheckbox}/>
						<label htmlFor={current_feature_node.feature._id}>{current_feature_node.feature.name}</label>
						<div className='feature-checkbox-helper'>
						{(() => {
							if (current_feature_node.feature.description) {
								const popover = 	(
									<Popover id={current_feature_node.feature._id}>
										<div>{current_feature_node.feature.description}</div>
									</Popover>
								)

								return (
									<OverlayTrigger
										trigger='click'
										placement={this.props.popoverPosition}
										overlay={popover}>
										<div className='fa fa-question-circle'/>
									</OverlayTrigger>
								)
							}
						})()}
						</div>
					</div>
				</div>
			)
		}
	}

	handleClickFeature() {
		this.setState({heading_open : !this.state.heading_open})
		this.props.toggleShowIndividualFeature(this.props.feature_node.feature.path);
	}

	render() {
  	var heading_class_name
  	var carrott_class_name

  	if (this.state.heading_open){
  		heading_class_name = this.props.featuresHeadingOpenClassName;
  		carrott_class_name = 'features-carrott fa fa-caret-up';
  	}
  	else {
  		heading_class_name= this.props.featuresHeadingClosedClassName;
  		carrott_class_name = 'features-carrott fa fa-caret-down';
  	}

  	var feature_wrapper_class_name;
  	var feature_body_class_name;

  	if (!this.props.isNested) {
  		feature_wrapper_class_name = this.props.parentFeatureWrapperClassName;
  		feature_body_class_name = this.props.parentFeatureBodyClassName;
  	}

  	else {
  		feature_wrapper_class_name = this.props.nestedFeatureWrapperClassName;
  		feature_body_class_name = this.props.nestedFeatureBodyClassName;
  	}

  	let features_open;

  	if(!this.props.features || !this.props.feature_node || ! this.props.feature_node.feature)
  		features_open = false
  	else
  		features_open = this.props.features.open_features.find(f 	=> f === this.props.feature_node.feature.path) !== undefined

    return (
  		<section className={`${feature_wrapper_class_name} feature-container`}>
  			<div
  				className={heading_class_name}
  				onClick={this.handleClickFeature}>
  				{(() => {
  					if (!this.props.isNested)
  						return <h4 style={{display : 'inline-block'}}>{this.props.feature_node.feature.name}</h4>
  					else
							return <h5>{this.props.feature_node.feature.name}</h5>
  				})()}
	  			<div className={carrott_class_name}/>
  			</div>
  			<Panel collapsible expanded={features_open}>
  				<div className={feature_body_class_name}>
	  				{this.props.feature_node.children.map(this.renderFeatureChildren)}
	  			</div>
  			</Panel>
  		</section>
    );
  }
}

let mapStateToProps = ({features, roleManagement, users}) => ({features, roleManagement, users})

export default connect(mapStateToProps, Actions)(Feature)



// WEBPACK FOOTER //
// ./src/browser/components/features/feature.js